<template>
  <thead class="rc-table__header">
    <tr>
      <th
        v-for="(item,index) in columns"
        :key="'header_'+index"
        :class="{ 'is-center': getAttrs(item).align === 'center' }"
        class="rc-table__header-cell">
        <div class="rc-table__cell">
          {{ getAttrs(item).label }}
        </div>
      </th>
    </tr>
  </thead>
</template>
<script type="text/ecmascript-6">
import getParentInfo from './getParentInfo'
export default {
  name: 'TableHeader',
  mixins: [getParentInfo],
}
</script>
<style rel="stylesheet/css" type="text/css" lang="scss">
@include b(table) {
  @include e(header-cell) {
    background-color: #fafafa;
  }

  th {
    .rc-table__cell {
      font-weight: 500;
      color: #141414;
    }
  }
}
</style>
